import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";
import axios from "axios";
import Locations from "./Locations";
import Add from "./Add";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result.map((item, index) => {
    item.priority = index;
    return item;
  });
};

class UserLocations extends React.Component {
  state = {
    locations: this.props.locations,
  };

  static url(id = null) {
    return `${window.location.pathname}${id ? `/${id}` : ""}`;
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-8 col-sm-6" />
          <div className="col-md-2 col-sm-3 col-xs-6">
            <div className="pull-right">
              <button
                className="btn btn-indigo btn-raised btn-long"
                onClick={this.handlerAddAll}
              >
                ADD ALL
              </button>
            </div>
          </div>
          <div className="col-md-2 col-sm-3 col-xs-6">
            <div className="pull-right">
              <Add onClick={this.handlerAdd} />
            </div>
          </div>
        </div>
        <br />

        <div className="row">
          <div className="col-md-12">
            <Locations
              data={this.state.locations}
              allLocations={this.props.allLocations}
              futureShiftCountByLocation={this.props.futureShiftCountByLocation}
              futureShiftActionOptions={this.props.futureShiftActionOptions}
              onDelete={this.handlerDelete}
              onSave={this.handlerSave}
              onRemove={this.handlerRemove}
              onDragEnd={this.handlerDragEnd}
            />
          </div>
        </div>
      </div>
    );
  }

  handlerDragEnd = (result) => {
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }

    const locations = reorder(
      this.state.locations,
      result.source.index,
      result.destination.index
    );

    this.setState({ locations }, this.updatePriorities);
  };

  handlerAddAll = () => {
    axios
      .post(`${window.location.pathname}/create_all`)
      .then((response) => {
        let newLocations = this.state.locations;
        newLocations = newLocations.concat(response.data);
        this.setState({ locations: newLocations });
        toastr.success("All locations access added");
      })
      .catch((error) => toastr.error("Something went wrong"));
  };

  handlerAdd = () => {
    this.setState({
      locations: this.state.locations.concat({
        _id: -new Date().getTime(),
        id: null,
        priority: this.state.locations.length,
        locationId: null,
        primary: false,
      }),
    });
  };

  handlerRemove = (_id) => {
    const locations = lodash.filter(this.state.locations, (l) => l._id !== _id);
    this.setState({ locations });
  };

  handlerDelete = (id, action) => {
    const locations = lodash.filter(this.state.locations, (l) => l.id !== id);
    this.setState({ locations });
    axios
      .delete(UserLocations.url(id), { params: { future_shift_action: action } })
      .then(() => {
        toastr.success("Location access removed");
      })
      .catch(() => toastr.error("Something went wrong"));
  };

  handlerSave = (id, dataLocation, callback) => {
    if (id) {
      this.update(id, dataLocation, callback);
    } else {
      this.create(dataLocation, callback);
    }
  };

  updatePriorities = () => {
    const data = this.state.locations
      .filter((l) => l.id)
      .map((l) => ({ id: l.id, priority: l.priority }));
    axios
      .put(UserLocations.url("priorities"), { data: data })
      .then(() => {
        toastr.success("Location order updated");
      })
      .catch((error) => toastr.error("Something went wrong"));
  };

  update = (id, dataLocation, callback) => {
    axios
      .put(UserLocations.url(id), dataLocation)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.locations, { id: id });
        const locations = this.state.locations;
        locations[idx] = data;

        this.setState({ locations }, () => {
          if (callback) {
            callback(true);
          }
        });
        toastr.success("Location access updated");
      })
      .catch(() => {
        if (callback) {
          callback(false);
        }
        toastr.error("Something went wrong");
      });
  };

  create = (dataLocation, callback) => {
    axios
      .post(UserLocations.url(), dataLocation)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.locations, {
          _id: dataLocation._id,
        });
        const locations = this.state.locations;
        locations[idx] = data;

        this.setState({ locations }, () => {
          if (callback) {
            callback(true);
          }
        });
        toastr.success("Location access added");
      })
      .catch(({ response }) => {
        if (callback) {
          callback(false);
        }
        toastr.error("Something went wrong");
      });
  };
}

UserLocations.propTypes = {
  locations: PropTypes.array.isRequired,
  allLocations: PropTypes.array,
  futureShiftCountByLocation: PropTypes.object,
  futureShiftActionOptions: PropTypes.array
};

export default UserLocations;
